module.exports = __webpack_public_path__ + "static/media/qrcode-weibo.4a5f21c5.jpg";